export function clientsOverviewSlider() {
    let $slider = $('.clients-overview-slider');
    $slider.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        speed: 750,
        pauseOnHover: false,
        mobileFirst: true,
        prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 7"><path d="M5 3.5 1.667 7 0 5.25 5 0l5 5.25L8.333 7 5 3.5Z"/></svg></button>',
        nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 7"><path d="M5 3.5 1.667 7 0 5.25 5 0l5 5.25L8.333 7 5 3.5Z"/></svg></button>',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.5
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 1799,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/clientsOverviewSlider.js